import React from 'react';
import { Image as KonvaImage } from 'react-konva';
import { Html } from 'react-konva-utils';
import {
  CarouselWrapper, SliderContainer, ThumbnailContainer,
  UploadButtonCanva, PlusIcon, Thumbnail
} from '../Canvas.styles.js';
import useImage from 'use-image';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BackgroundManager = ({
  CANVAS_WIDTH,
  CANVAS_HEIGHT,
  backgroundSrc,
  setBackgroundSrc,
  backgroundImages,
  setBackgroundImages
}) => {
  const [backgroundImage] = useImage(backgroundSrc);

  const carouselSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    lazyLoad: 'ondemand',
    touchThreshold: 10,
    waitForAnimate: false,
    useCSS: true,
    useTransform: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  const calculateCoverImage = (canvasWidth, canvasHeight, imageWidth, imageHeight) => {
    const canvasRatio = canvasWidth / canvasHeight;
    const imageRatio = imageWidth / imageHeight;
    let width, height;
    if (canvasRatio > imageRatio) {
      width = canvasWidth;
      height = canvasWidth / imageRatio;
    } else {
      width = canvasHeight * imageRatio;
      height = canvasHeight;
    }
    return {
      width,
      height,
      offsetX: width / 2,
      offsetY: height / 2,
    };
  };

  const handleBackgroundUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newImage = { src: e.target.result, label: `Fondo ${backgroundImages.length + 1}` };
        setBackgroundImages(prev => [...prev, newImage]);
        setBackgroundSrc(newImage.src);
      };
      reader.readAsDataURL(file);
    }
  };

  const renderBackground = () => {
    if (!backgroundImage) return null;
    const { width, height, offsetX, offsetY } = calculateCoverImage(
      CANVAS_WIDTH,
      CANVAS_HEIGHT,
      backgroundImage.width,
      backgroundImage.height
    );
    return (
      <KonvaImage
        image={backgroundImage}
        width={width}
        height={height}
        x={CANVAS_WIDTH / 2}
        y={CANVAS_HEIGHT / 2}
        offsetX={offsetX}
        offsetY={offsetY}
      />
    );
  };

  return (
    <>
      {renderBackground()}
      <Html
        divProps={{
          style: {
            position: 'absolute',
            top: 'unset',
            bottom: 0,
            width: '100%',
            padding: '0px 10px',
          }
        }}
      >
        <CarouselWrapper>
          <SliderContainer>
            <Slider {...carouselSettings}>
              <ThumbnailContainer>
                <UploadButtonCanva>
                  <input type="file" onChange={handleBackgroundUpload} accept="image/*" />
                  <PlusIcon>+</PlusIcon>
                </UploadButtonCanva>
              </ThumbnailContainer>
              {backgroundImages.map((bg, index) => (
                <ThumbnailContainer key={index}>
                  <Thumbnail
                    src={bg.src}
                    alt={bg.label}
                    onClick={() => setBackgroundSrc(bg.src)}
                    selected={backgroundSrc === bg.src}
                  />
                </ThumbnailContainer>
              ))}
            </Slider>
          </SliderContainer>
        </CarouselWrapper>
      </Html>
    </>
  );
};

export default BackgroundManager;